export default {
    namespaced: true,
    state: {
        //total number of questions displayed by default
        noQuestions: null
    },
    mutations: {
        setNoQuestions(state, value) {                    
            state.noQuestions = value;              
        },
    },
    actions: {
        mutateSetNoQuestions({commit}, val) {
            commit('setNoQuestions', val);
        },
    }
}
